import { Card, CardContent } from '../ui/card';
import { Focus, Users, Sparkles } from 'lucide-react';

const experiences = [
  {
    icon: Focus,
    title: "Stay Centered When It Matters Most",
    description: "Learn to access calm clarity in the chaos of 10-10, third set, and in high-stakes conversations off the court."
  },
  {
    icon: Users,
    title: "Two Bodies Move as One",
    description: "Develop the subtle art of doubles synchronicity where anticipation, trust, and seamless communication become your greatest competitive advantage."
  },
  {
    icon: Sparkles,
    title: "Play From Your Natural Intelligence",
    description: "Stop overthinking your way out of great shots. Access the embodied wisdom that knows exactly what to do before your mind catches up."
  }
];

const PickleballExperience = () => {
  return (
    <section className="container-mobile section-spacing max-w-5xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-foreground mb-4">
          Transform How You Show Up
        </h2>
        <p className="text-foreground/85 text-lg max-w-2xl mx-auto">
          In pressure, partnership, and power.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-3">
        {experiences.map((item, i) => (
          <Card key={i} className="bg-gradient-to-br from-primary/10 via-primary/5 to-transparent border border-primary/20">
            <CardContent className="p-8 text-center">
              <item.icon className="h-10 w-10 text-primary mx-auto mb-4" />
              <h3 className="text-foreground font-display text-xl mb-3">{item.title}</h3>
              <p className="text-foreground/85">{item.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default PickleballExperience;
